import { UpdateInvoiceParams, updateInvoicePaymentMethod } from "@NA/Services/ADIInvoiceService";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<UpdateInvoiceParams, any>;

export const UpdatePaymentRecap: HandlerType = async (props: any) => {
    props.apiResult = await updateInvoicePaymentMethod(props.parameter);
};

export const chain = [UpdatePaymentRecap];

const updateInvoicePayment = createHandlerChainRunner(chain, "updateInvoicePayment");
export default updateInvoicePayment;
